import { useSearchQueryModal } from 'src/hooks/useSearchQuery'

export interface IUseRouterGlobalSearchSearchQuery {
  modal: string
  globalSearch?: string
}

export const modalName = 'global-search'

export const useRouterGlobalSearch = () => {
  const search = useSearchQueryModal<IUseRouterGlobalSearchSearchQuery>()

  const open = (searchText?: string) => {
    search.setQuery({
      modal: modalName,
      globalSearch: searchText,
    })
  }

  const close = () => {
    search.removeQuery(['modal', 'globalSearch'])
  }

  return {
    search,
    globalSearch: search.query.globalSearch ?? '',
    isOpen: Boolean(search.query.modal === modalName),
    close,
    open,
  }
}
